import Hebcal from "hebcal";

const dateToFullHebrew = (date) => {
  return date ? `${dayToHebrew((
    Hebcal.HDate(new Date(date)).getDay() + 1
  ) )} ${Hebcal.gematriya(
    Hebcal.HDate(new Date(date)).getDate("h")
  )} ${Hebcal.HDate(new Date(date)).getMonthName("h")}  |  ${new Date(
    date
  ).getDate()}.${new Date(date).getMonth() + 1}.${new Date(date)
    .getFullYear()
    .toString()
    .slice(2, 4)}` : null;
};

const toFullHebrewWeekRange = (date) => {
  if (date == null) return null
  const weekRange = getWeekRange(date)
  return `${dateToFullHebrew(weekRange.firstDay)}   -   ${dateToFullHebrew(weekRange.lastDay)}`
};

const dateToOnlyHebrewAndTime = (date) => {
  const dateObj = new Date(date)
  return date ? `${dayToHebrew(
      Hebcal.HDate(dateObj).getDay() + 1
  )} ${Hebcal.gematriya(
      Hebcal.HDate(dateObj).getDate("h")
  )} ${Hebcal.HDate(dateObj).getMonthName("h")}  | ${dateObj.getHours()}:${dateObj.getMinutes()}` : null;
};

const dateToOnlyHebrew = (date) => {
  const dateObj = new Date(date)
  return date ? `${dayToHebrew(
      Hebcal.HDate(dateObj).getDay() + 1
  )} ${Hebcal.gematriya(
      Hebcal.HDate(dateObj).getDate("h")
  )} ${Hebcal.HDate(dateObj).getMonthName("h")}` : null;
};

const dateToHebrewAndTime = (date) => {
  const dateObj = new Date(date)
  return date ? `${dayToHebrew(
      Hebcal.HDate(dateObj).getDay() + 1
  )} ${Hebcal.gematriya(
      Hebcal.HDate(dateObj).getDate("h")
  )} ${Hebcal.HDate(dateObj).getMonthName("h")}  |  ${new Date(
      date
  ).getDate()}.${dateObj.getMonth() + 1}.${dateObj
      .getFullYear()
      .toString()
      .slice(2, 4)} | ${dateObj.getHours()}:${dateObj.getMinutes()}` : null;
};

const dayToHebrew = (day) => {
  switch (day) {
    case 7:
      return "שבת";
    case 1:
      return "ראשון";
    case 2:
      return "שני";
    case 3:
      return "שלישי";
    case 4:
      return "רביעי";
    case 5:
      return "חמישי";
    case 6:
      return "שישי";
  }
};

const getWeekRange = (date) => {
  // const copy  = new Date();
  // const copy2 = Object.assign({}, date);
  const curr = new Date(date)
  const first = curr.getDate() - curr.getDay(); // First day is the day of the month - the day of the week
  const last = first + 6; // last day is the first day + 6

  const firstday = new Date(curr.setDate(first)).toUTCString();
  const lastday = new Date(curr.setDate(last)).toUTCString();
  //
  // console.log("datedatedate", date)
  // const startOfWeek = new Date(date)
  // console.log("startOfWeek-1", startOfWeek)
  //
  // startOfWeek.setDate(startOfWeek.getDate() - ((startOfWeek.getDay())));
  // startOfWeek.setHours(5)
  // startOfWeek.setMinutes(0)
  // startOfWeek.setSeconds(0)
  // startOfWeek.setMilliseconds(0)
  // console.log("startOfWeek-2", startOfWeek)
  //
  // const endOfWeek = new Date(date)
  // endOfWeek.setDate(endOfWeek.getDate() + (7 - endOfWeek.getDay()));
  // endOfWeek.setHours(0)
  // endOfWeek.setMinutes(0)
  // endOfWeek.setSeconds(0)
  // endOfWeek.setMilliseconds(0)

  return {
    firstDay: firstday,
    lastDay: lastday
  };
}

const getPreviousWeekDate = (date) => {
  const previousWeekDate = new Date(date);
  previousWeekDate.setDate(date.getDate() - 7);
  return previousWeekDate;
}

const getNextWeekDate = (date) => {
  const previousWeekDate = new Date(date);
  previousWeekDate.setDate(date.getDate() + 7);
  return previousWeekDate;
}

const getDay = (date) => {
  return new Date(date).getDay();
}

export { dateToFullHebrew ,dateToOnlyHebrew,  dateToHebrewAndTime, dateToOnlyHebrewAndTime, getWeekRange, getPreviousWeekDate, getDay, getNextWeekDate, toFullHebrewWeekRange};
